import gql from "graphql-tag";


export const GET_AREAS = gql`
 query area($cityId:uuid!, $areaGroupId:uuid!){
  area(where: {_and: [{ cityId: {_eq: $cityId}},{ groupId: {_eq: $areaGroupId}}]}) {
    id
    area
    areaGroup{
      name
      id
       }
    city{
     id
     city
      }
   }
 }
`
export const GET_MAPPED_AREAS = gql`
 query {
  area {
    id
    area
    areaGroup { id name }
  }
 }
`
export const GET_AREAS_BY_CITY = gql`
 query area($cityId:uuid!){
  area(where: {_and: [{ cityId: {_eq: $cityId}}]}) {
    id
    area
   }
 }
`
